export const DestOptions = [
    "External Bank Account",
    "Crypto Wallet",
    "Cash Account"
]

export const Coins = [
    {
        title: "BTC",
        alias: "btc",
        subMenu: []
    },
    {
        title: "ETH",
        alias: "eth",
        subMenu: []
    },
    {
        title: "USDT",
        alias: "usdt-eth",
        subMenu: [{title: "TRC20", alias: "usdt-trc"}, {title: "ERC20", alias: "usdt-erc"}]
    },
    {
        title: "USDC",
        alias: "usdt-trx",
        subMenu: []
    },
]